export default "__VITE_ASSET__BZKjcIE1__"